export default {
    direction: "ltr",
    palette: {
        type: 'light',
        primary: {
            main: '#2680EB'
        },
        // background: {
        //     default: '#F3F3F3'
        // }
    },
    typography: {
        // fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
        fontWeightRegular: 600
    }
};